import { useState } from "preact/hooks";

const same = (a: unknown, b: unknown) => Object.is(a, b) || JSON.stringify(a) === JSON.stringify(b);

/**
 * A text box's own text for the value it edits (a number, JSON, a duration). What's typed stays as typed (the value
 * written another way, or not parsing yet); a value changed from outside (another row's after a removal, a newer
 * version merged in, a form cleared) replaces it, unless the text already means it.
 */
export function useValueText<V>(
  value: V,
  show: (v: V) => string,
  means: (text: string, v: V) => boolean,
): [string, (text: string) => void] {
  const [text, setText] = useState(() => show(value));
  const [last, setLast] = useState(value);
  if (!same(last, value)) {
    setLast(value);
    if (!means(text, value)) {
      setText(show(value));
    }
  }
  return [text, setText];
}
